module.exports = __webpack_public_path__ + "static/media/play.c17517b0.svg";